import { getYear, getMonth, getDate } from 'date-fns';

const getPartsFromDate = (
  date: Date,
): [[string | number, string | number, string | number]] => {
  return [[getYear(date), getMonth(date) + 1, getDate(date)]];
};

export default getPartsFromDate;
